import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {ConfirmResponse} from "../types/confirm";


export const fetchConfirmData = createAsyncThunk<ConfirmResponse, { key: string }>(
    'confirm/fetchConfirmData',
    async (authData, thunkAPI) => {
        try {
            const response = await axios.post<ConfirmResponse>('/api/registration/confirm', authData);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);